import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IonicModule } from "ionic-angular";
import { ToggleControlComponent } from "./toggle-control.component";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule.forChild()
    ],
    declarations: [
        ToggleControlComponent
    ],
    exports: [
        ToggleControlComponent
    ]
})
export class ToggleControlModule {}



// WEBPACK FOOTER //
// ./src/vas/controls/toggle/form/toggle-control.module.ts